module.exports = __webpack_public_path__ + "static/img/5.c8c78bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quartos/suite1/5.jpg
// module id = FN1x
// module chunks = 1